export function isNullOrEmpty(input) {
    return input === null || input === undefined || input === '' || input === 0;
}

export const GetInvoiceFormRowTitleFlex = (isSmallScreen = false) => {
    if (isSmallScreen) {
        return 0.4
    }
    return 0.15;
};
export function formatNumberWithDecimals({ number, defaultValue = '-', showCurrency = true, locale = 'zh-Hans', currency = 'CNY' }) {
    const parsedNumber = parseFloat(number);
    if (isNaN(parsedNumber)) {
        return defaultValue;
    }

    const formattedNumber = parsedNumber.toLocaleString(locale, {
        style: showCurrency ? 'currency' : 'decimal',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });

    return formattedNumber;
}

export function convertServerMessageToClient(errorMessage, t) {
    const translations = {
        'Receipt Not Found': t('error.receiptNotFound'),
        "Tax amount exceeds": t('error.taxAmoutReachedLimit'),
    };

    return translations?.[errorMessage] || errorMessage;
}